(function() {
  var menuItems = document.querySelectorAll('.hs-menu-wrapper.flyouts > ul > li');
  var subMenuItems = document.querySelectorAll('.hs-menu-wrapper.flyouts > ul > li > ul > li');
  Array.prototype.forEach.call(menuItems, function(el, i) {
    el.querySelector('a').addEventListener("focus", function(event) {
      var openMenu = document.querySelector('.hs-menu-wrapper.flyouts > ul > li > ul.open-menu-list');
      var hasList = this.parentNode.querySelector('ul');
      if (openMenu) {
        openMenu.removeAttribute("style");
        openMenu.classList.remove("open-menu-list");
      }

      openMenu && openMenu.parentNode.querySelector("a").setAttribute("aria-expanded", "false");
      if (hasList) {
        hasList.style.visibility = "visible";
        hasList.style.opacity = "1";
        hasList.style.display = "block";
        hasList.classList.add("open-menu-list");
      }

      hasList && this.setAttribute("aria-expanded", "true");
    });

    Array.prototype.forEach.call(el.querySelectorAll('ul li:last-child > a'), function(el, i) {
      el.addEventListener("blur",function(event) {
        if (!this.parentNode.querySelector('ul')) {
          var menu = this.parentNode.parentNode;
          if (menu) {
            menu.removeAttribute("style");
            menu.classList.remove("open-menu-list");
          }
          this.parentNode.parentNode.parentNode.querySelector("a").setAttribute("aria-expanded", "false");
        }
      });
    });

    el.querySelector('a').addEventListener("mouseout", function(event) {
      var openMenu = document.querySelector('.hs-menu-wrapper.flyouts > ul > li > ul.open-menu-list');
      if (openMenu) {
        openMenu.removeAttribute("style");
        openMenu.classList.remove("open-menu-list");
      }
      openMenu && openMenu.parentNode.querySelector("a").setAttribute("aria-expanded", "false");
    });
  });

  Array.prototype.forEach.call(subMenuItems, function(el, i) {
    el.querySelector('a').addEventListener("focus", function(event) {
      var openSubMenu = document.querySelector('.hs-menu-wrapper.flyouts > ul > li > ul ul.open-menu-list');
      var hasSubList = this.parentNode.querySelector('ul');
      if (openSubMenu) {
        openSubMenu.removeAttribute("style");
        openSubMenu.classList.remove("open-menu-list");
      }
      openSubMenu && openSubMenu.querySelector("a").setAttribute("aria-expanded", "false");
      if (hasSubList) {
        hasSubList.style.visibility = "visible";
        hasSubList.style.opacity = "1";
        hasSubList.style.display = "block";
        hasSubList.classList.add("open-menu-list");
      }
      hasSubList && this.parentNode.querySelector("a").setAttribute("aria-expanded", "true");
    });

    el.querySelector('a').addEventListener("mouseout", function(event) {
      var openMenu = document.querySelector('.hs-menu-wrapper.flyouts > ul > li > ul ul.open-menu-list');
      if (openMenu) {
        openMenu.removeAttribute("style");
        openMenu.classList.remove("open-menu-list");
      }
      openMenu && openMenu.querySelector("a").setAttribute("aria-expanded", "false");
    });
  });
})();


